import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ArchiveService } from '../../services';
import { BaseComponent } from '../../shared';


/**
* Pagination component that handles result pages in archive list.
*/
@Component({
	selector: 'archive-pagination',
	templateUrl: './archive-pagination.component.html',
	imports: [
		FormsModule,
		NgbPaginationModule
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class ArchivePaginationComponent extends BaseComponent implements OnInit, OnDestroy {

	private readonly archiveSrv = inject(ArchiveService);

	readonly pageSizeList = [10, 15, 20, 25, 50];
	page: number = 1;
	pageSize: number = this.pageSizeList[0];
	collectionSize: number = 0;
	totalPages: number = 0;

	private _searchResultSub$?: Subscription;


	ngOnInit(): void {
		this._searchResultSub$ = this.archiveSrv.getSearchResult().subscribe(list => {
			this.collectionSize = list ? list.count : 0;
			this.totalPages = this.pageSize ? Math.ceil(this.collectionSize / this.pageSize) : 1;
		});
		this.initPagination();
	}

	private initPagination(): void {
		this.page = this.archiveSrv.getPageNumber() + 1;
		this.pageSize = this.archiveSrv.getPageSize();
	}

	/**
	* Update list according the page number selected.
	*/
	changePageNumber(page: number): void {
		this.page = page;
		this.archiveSrv.changePageNumber(page - 1);
	}

	/**
	* Update list according the page size selected.
	*/
	changePageSize(): void {
		this.page = 1;
		this.archiveSrv.changePageSize(this.pageSize);
	}


	ngOnDestroy(): void {
		this._searchResultSub$?.unsubscribe();
	}

}
